import { render, staticRenderFns } from "./FormDeleteModal.vue?vue&type=template&id=2e50dbd0&scoped=true"
import script from "./FormDeleteModal.vue?vue&type=script&lang=js"
export * from "./FormDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./FormDeleteModal.vue?vue&type=style&index=0&id=2e50dbd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e50dbd0",
  null
  
)

export default component.exports